import PanelData from '@/view/world-cup/PanelData.vue'
import DFData from '@/view/world-cup/DFData.vue'
import PlayerPlayType from '@/view/world-cup/PlayerPlayType.vue'
import TeamPlayerType from '@/view/world-cup/TeamPlayerType.vue'
import SquadData from '@/view/world-cup/SquadData.vue'
import LAYOUT from '@/layout/index.vue'
import { RouteRecordRaw, RouterView } from 'vue-router'

export default [
    {
        name: 'layout',
        path: '/',
        redirect: '/world-cup/home',
        meta: {
        title: '',
    },
    component: LAYOUT,
    children: [
        {
            name: 'home',
            path: 'home',
            meta: {
                title: '首页',
            },
            component: () => import('@/view/home/index.vue'),
        },
    ],
    },
    {
    name: 'world-cup',
    path: '/world-cup',
    redirect: '/world-cup/home',
    meta: {
        title: '世预赛比赛分析',
    },
    component: RouterView,
    children: [
        {
            name: 'worldCupQualifier',
            path: 'home',
            component: () => import('@/view/world-cup/index.vue'),
        },
        {
            name: 'worldCupPanelData',
            path: 'world-cup-panel-data',
            component: PanelData,
        },
        {
            name: 'worldCupDFData',
            path: 'world-cup-DF-data',
            component: DFData,
        },
        {
            name: 'worldCupPlayTypeData',
            path: 'world-cup-play-type-data',
            component: PlayerPlayType,
        },
        {
            name: 'worldCupTeamPlayTypeData',
            path: 'world-cup-team-play-type-data',
            component: TeamPlayerType,
        },
        {
            name: 'worldCupTeamSquadData',
            path: 'world-cup-team-squad-data',
            component: SquadData,
        },
    ],
} as RouteRecordRaw]
